import React, { useEffect, useRef } from "react";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { RadioGroup, RadioGroupItem } from "../../../components/ui/radio-group";
import { Button } from "../../../components/ui/button";

const SpotFormMobile = ({
  spotFormViewModel,
  formRef,
  onFormSubmitted,
  initiatePayment,
}) => {
  const name = useRef(null);
  const contactNumber = useRef(null);
  const email = useRef(null);
  let selectedDate = useRef(null);

  useEffect(() => {
    selectedDate.current = spotFormViewModel.tripDates[0];
  }, [spotFormViewModel]);

  const submitHandler = () => {
    onFormSubmitted(
      name.current.value,
      contactNumber.current.value,
      email.current.value,
      selectedDate.current
    );
    name.current.value = "";
    contactNumber.current.value = "";
    email.current.value = "";
    selectedDate.current = spotFormViewModel.tripDates[0];
  };

  const BookingHandler = () => {
    if (
      !name.current.value ||
      !contactNumber.current.value ||
      !email.current.value
    ) {
      alert("Please fill all the fields");
      return;
    }
    initiatePayment(name.current.value, contactNumber.current.value, email.current.value,spotFormViewModel.bookingAmount);
  };

  return (
    <>
      <div id="spot-form-mobile" ref={formRef} className="bg-white p-4">
        <h1 className="text-3xl font-bold mb-6">What's Stopping you?</h1>
        <div className="bg-gray-100 p-4 rounded-lg">
          <h2 className="text-xl font-semibold mb-4">Book Your Spot</h2>
          <Input
            ref={name}
            className="my-4"
            placeholder="Full Name"
            type="text"
          />
          <Input
            ref={contactNumber}
            className="my-4"
            placeholder="Phone No."
            type="tel"
          />
          <Input
            ref={email}
            className="my-4"
            placeholder="Email"
            type="email"
          />
          <legend className="text-sm my-4 font-medium mb-1">
            Select Date: *
          </legend>
          <RadioGroup className="my-4" defaultValue="0">
            {spotFormViewModel.tripOptionDates.map((td, index) => (
              <div key={index} className="flex items-center space-x-2">
                <RadioGroupItem
                  id={`r-${index}`}
                  value={index.toString()}
                  onClick={() => {
                    selectedDate.current = spotFormViewModel.tripDates[index];
                  }}
                />
                <Label htmlFor={`r-${index}`}>{td}</Label>
              </div>
            ))}
          </RadioGroup>
          <Button
            className="w-full bg-orange-600 text-white"
            onClick={submitHandler}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};

export default SpotFormMobile;
